/**
 * Accounting Statement Domain Types
 * Defines types for periodic financial reports (bilans comptables)
 */
/**
 * Default operation status inclusion (only reconciled)
 */
export const DEFAULT_OPERATION_STATUS_INCLUSION = {
    reconciled: true,
    pointed: false,
    unpointed: false,
};
//# sourceMappingURL=accounting-statement.js.map